import { Placeholders } from '../fillDynamicText';

const getTwitterShareUrl = (
    tweetText,
    twitterMention,
    postalCode,
    partnerName,
    publisherName,
    articleUrl,
    hideSymbol,
    repState,
    repDistrict
) => {
    const text = tweetText
        .replace(new RegExp(Placeholders.LocalRepresentative, 'g'), '')
        .replace(
            new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
            twitterMention || '@Speakable'
        )
        .replace(new RegExp(Placeholders.PostalCodePlaceholder, 'g'), postalCode || '')
        .replace(new RegExp(Placeholders.PartnerTwitterMention, 'g'), partnerName || '')
        .replace(new RegExp(Placeholders.StatePlaceholder, 'g'), repState || '')
        .replace(new RegExp(Placeholders.DistrictPlaceholder, 'g'), repDistrict || '')
        .replace(
            new RegExp(Placeholders.PublisherTwitterMention, 'g'),
            publisherName || ''
        )
        .replace(new RegExp(Placeholders.ArticleUrl, 'g'), articleUrl || '')
        .replace(/@/g, hideSymbol ? '' : '@')
        .replace(/<span id="partnerName">/g, '')
        .replace(/<\/span>/g, '');
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
};

export default getTwitterShareUrl;
